<template>
  <div id="moe-header">
    <div class="header">
      <div class="header__wrap">
        <a
          class="header__brand"
          :href="isTeReo && !isTeReoMaoriPage && !isTmoaTrmpPage ? '/mi' : '/'"
        >
          <img
            class="header__logo"
            src="/themes/custom/ncea/dist/images/moe-logo-black.svg"
            aria-label="Ministry of Education Logo"
            alt="Ministry of Education New Zealand"
            title="Ministry of Eduction New Zealand"
          />
          <div class="header__title">NCEA Education</div>
        </a>
        <div class="menus-wrapper">
          <div class="menus-wrapper-backdrop">
            <div class="menus-wrapper-backdrop__mob-nav-close">
              <img
                class="subjects-nav-mob-nav-close"
                src="/themes/custom/ncea/dist/images/icon-light-close-white.svg"
                alt="Close subjects nav"
              />
            </div>
          </div>
          <div class="header__mob-language-toggle">
            <slot name="language-toggle" />
          </div>
          <slot name="menus" />
        </div>
        <div class="header__language-toggle">
          <slot name="language-toggle" />
        </div>
        <GlossaryLink :is-te-reo="isTeReo" />
        <div
          v-if="showSearch"
          class="header__search"
        >
          <SiteSearch
            class="search"
            :algolia-index-name="siteSearchIndexName"
            :is-te-reo="isTeReo"
          />
          <font-awesome-icon
            id="primary-menu-mob-nav-open"
            class="header__hamburger"
            icon="bars"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SiteSearch from '../search/SiteSearch.vue';
import GlossaryLink from '../GlossaryLink/GlossaryLink.vue';

export default {
  name: 'MoeHeader',
  components: {
    SiteSearch,
    GlossaryLink,
  },
  props: {
    siteSearchIndexName: {
      type: String,
      required: true,
    },
    showSearch: {
      type: Boolean,
      required: false,
      default: true,
    },
    isTeReo: {
      type: Boolean,
      required: false,
      default: false,
    },
    isTeReoMaoriPage: {
      type: Boolean,
      required: false,
      default: false,
    },
    isTmoaTrmpPage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
/* stylelint-disable-next-line unit-disallowed-list */
$size-hamburger-width: 24.5px;
/* stylelint-disable-next-line unit-disallowed-list */
$size-hamburger-height: 28px;
/* stylelint-disable-next-line unit-disallowed-list */
$breakpoint-mobile-small: 340px;

.header {
  position: relative;
  height: $size-header-height;
  background-color: white;
  z-index: 31;

  @include breakpoint-tablet-down {
    overflow: hidden;
  }

  &__brand {
    display: flex;
    align-items: center;
    text-decoration: none;
    border: none;
    margin-right: auto; // Brand is always left-algined even in `flex-end` justified mobile view.

    img {
      width: 4.44rem;
      height: 4.44rem;
    }
  }

  &__title {
    display: flex;
    align-items: center;
    height: 4.44rem;
    white-space: nowrap;
    box-sizing: border-box;
    color: $color-charcoal-mid;
    font-weight: 800;
    padding: 0 1.5rem;
    text-decoration: none;
    line-height: 1.2;

    @include breakpoint-tablet-down {
      padding: 0 0 0 1.5rem;
      min-width: auto;
      border: none;
      white-space: normal;
    }

    @media only screen and (max-width: #{$breakpoint-mobile-small}) {
      font-size: 0.78rem;
    }
  }

  &__logo {
    background-color: white;
    background-size: 100% 100%;
    height: $size-header-height;
    min-height: $size-header-height;
    width: $size-header-height;
    min-width: $size-header-height;
    overflow: hidden;
    position: relative;

    img {
      max-width: 100%;
    }

    &::before {
      background: red;
      bottom: 100%;
      height: 2rem;
      position: absolute;
      width: 100%;
    }
  }

  &__hamburger {
    display: none;
    width: $size-hamburger-width;
    width: $size-hamburger-height;
    margin-left: 1rem;
    color: $color-charcoal-mid;

    @include breakpoint-tablet-down {
      display: inline-block;
      margin-right: 1rem;
      margin-top: 0;
    }
  }

  &__wrap {
    align-items: center;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    padding-right: 1.5rem;
    column-gap: 1.5rem;

    @include breakpoint-desktop-down {
      padding-right: 0;
      column-gap: 1rem;
    }

    @include breakpoint-tablet-down {
      justify-content: flex-end;
    }

    body.basic_page & {
      border-bottom: $border-width solid $color-pale-grey-s2;
    }
  }

  &__search {
    display: flex;
    align-items: center;
  }

  &__mob-nav-toggle {
    width: 1.5rem;
    height: 1.5rem;
    margin: 1rem;
  }

  &__mob-nav-toggle-icon {
    width: 100%;
    height: 100%;
  }

  &__language-toggle {
    @include education-breakpoint-mobile-down {
      display: none;
    }
  }

  &__mob-language-toggle {
    display: none;

    .user-logged-in & {
      margin-top: 3rem;
    }

    .menus-wrapper--expanded-subjects & {
      display: block;
      padding: 3rem 1rem 0 1rem;
    }
  }
}

.search {
  box-sizing: border-box;

  @include breakpoint-tablet-down {
    border: none;
  }
}

//Accessibilty links to navigation
/* stylelint-disable-next-line no-descending-specificity */
.skip-links__link {
  left: -100%;
  overflow: hidden;
  padding: 0.25rem;
  position: absolute;
  text-decoration: underline;
  top: -100%;

  &:focus,
  &:active {
    display: inline-block;
    height: auto;
    left: 0;
    margin-bottom: 0.25rem;
    overflow: visible;
    position: static;
    top: 0;
    width: auto;
  }

  &::before {
    display: none;
  }
}

.mobile-nav {
  visibility: hidden;
  opacity: 0;
  transform: translateX(150%);
  transition: $duration-transition-standard ease-in;
  z-index: 900;

  &.nav-open {
    visibility: visible;
    opacity: 1;
    transform: translateX(0);

    @include breakpoint-sm-up {
      visibility: hidden;
      opacity: 0;
    }
  }
}
</style>
